import cssVariables from 'tfs.css-variables'

export default {
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  wrapper: {
    minHeight: '21em',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    animation: 'fadeIn 0.15s ease 0.15s forwards',
  },
  wrapperWithLoadingIcon: {
    minHeight: '21em',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    animation: 'fadeIn 0.15s ease 0.15s forwards',
  },
  header: {
    padding: '2em 8em 1em 8em',
    textAlign: 'center',
  },
  title: {
    color: cssVariables.colorBlue,
  },
  icon: {
    color: cssVariables.colorWarning,
    fontSize: '2em',
    lineHeight: '2em',
  },
  content: {
    flex: 1,
    width: '100%',
    backgroundColor: cssVariables.colorWhiteHover,
    borderRadius: '0 0 1em 1em',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '80% 20%',
    padding: '1.5em 8em 1.5em 8em',
    borderBottom: `thin solid ${cssVariables.colorGrayE}`,
    '&:last-child': {
      paddingBottom: '2.5em',
      borderBottom: 'none',
    },
  },
  rowHeader: {
    borderBottom: 'none',
    gridTemplateColumns: '20% 20% 20% 20% 20%',
    paddingBottom: '0',
    '&>h4': {
      margin: '0',
    },
  },
  flightRoute: {
    padding: '1.5em 0em 0em 8em',
    fontWeight: 'bold',
  },
  paddingTop: {
    paddingTop: '1em',
  },
  flightInformation: {
    display: 'grid',
    gridTemplateColumns: '25% 25% 25% 25%',
  },
  loadingIndicator: {
    fontSize: '3rem',
    color: cssVariables.colorBlue,
  },
  resize: {
    transition: 'width 0.15s ease-in',
  },
}
